require('./angulartics');
module.exports = 'angulartics';



//////////////////
// WEBPACK FOOTER
// ./~/angulartics/src/index.js
// module id = 753
// module chunks = 0